import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { updateAutoSaveOption } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function postProcedureDetails({
  AccountId,
  Procedure,
}: TVariables): Promise<TResult> {
  const response = await fetch(updateAutoSaveOption(AccountId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(Procedure),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  AccountId: number;
  Procedure: {
    ProcedureId: number;
    IsAutoSave: boolean;
  };
};

type TSnapshot = unknown;

function useUpdateProcedureAutoSave(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const { AccountId } = params;
    const updatedResult = await postProcedureDetails(params);
    if (updatedResult.Data) {
      queryClient.invalidateQueries(
        ['get_procedure_builder_procedures', AccountId],
        {
          refetchInactive: true,
        },
      );
      queryClient.invalidateQueries(['get_procedure', AccountId], {
        refetchInactive: true,
      });
    } else if (updatedResult.Errors) throw updatedResult.Errors;
    return updatedResult;
  });
}

export { useUpdateProcedureAutoSave };
